import React, { useCallback, useState } from 'react'
import { toAbsoluteUrl } from '_metronic/helpers'
import { Modal, Button } from 'react-bootstrap-v5';
import PrivacyPolicy from '../auth/components/PrivacyPolicy';
import TnC from '../auth/components/TnC';

const Home: React.FC = () => {
  const [showTermsModal, setShowTermsModal] = useState(false)
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const handleTermsClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    setShowTermsModal(true)
  }, [])

  const handlePrivacyClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault()
    setShowPrivacyModal(true)
  }, [])


  return (
    <div className='container-xxl px-0' style={{ background: 'linear-gradient(120deg, #5f6fff 0%, #38cfff 100%)', minHeight: '100vh' }}>
      {/* Top Nav & Logo */}
      <div className='d-flex align-items-center justify-content-between px-10 pt-8 pb-4'>
        <div className='d-flex align-items-center gap-3'>
          <img src={toAbsoluteUrl('cover_logo.jpg')} alt='Logo' style={{ height: 32, borderRadius: 6, background: '#fff', boxShadow: '0 2px 8px #0001' }} />
          <span className='fs-2x fw-bold text-white'>VideoJobFairs</span>
        </div>
        <div className='d-none d-lg-flex gap-5'>
          <a className='text-white fw-semibold fs-5 text-decoration-none border-bottom border-white pb-1' style={{ opacity: 0.9 }} href='#'>Home</a>
          <a className='text-white fw-semibold fs-5 text-decoration-none' style={{ opacity: 0.7 }} href='/auth/login'>Company login</a>
        </div>
        <a href='mailto:Sales@VideoJobFairs.com' className='btn btn-light-primary fw-bold px-6 py-2 rounded-pill shadow-sm'>Contact Sales</a>
      </div>

      {/* Hero Section */}
      <div className='row align-items-center justify-content-between px-10 py-2' style={{ minHeight: 150 }}>
        <div className='col-lg-6 mb-6 mb-lg-0'>
          <h1 className='display-5 fw-bold text-white mb-3 lh-tight'>
            White Label Virtual Job Fairs for <span className='text-warning'>Newspapers</span> & <span className='text-warning'>Associations</span>
          </h1>
          <p className='fs-6 text-white mb-4' style={{ maxWidth: 700 }}>
            Host branded job fairs for your clients. Our platform powers every step, from setup to live video interviews, with no competition for candidates.
          </p>
          <div className='mb-2 text-white'>
            Email: <a href='mailto:Sales@VideoJobFairs.com' className='text-white text-decoration-underline fw-semibold'>Sales@VideoJobFairs.com</a>
          </div>
          <div className='mb-2 text-white'>
            Phone: <a href='tel:7038501853' className='text-white text-decoration-underline fw-semibold'>(703) 850-1853</a>
          </div>
          <div className='mb-2 text-white' >
            Business Name: Video Job Fairs LLC
          </div>
        </div>
        <div className='col-lg-6 d-flex justify-content-center'>
          <img
            src={toAbsoluteUrl('vjfp-laptop.png')}
            alt='Virtual Job Fair'
            style={{
              maxHeight: 340
            }}
          />
        </div>
      </div>


      {/* Advantages Section */}
      <div className='row g-12 justify-content-center mb-15'>
        <div className='col-lg-5 mb-6 mb-lg-0'>
          <div className='card h-100 border-0 shadow rounded-4 bg-white' style={{ background: 'linear-gradient(120deg,rgb(240, 204, 231) 0%,rgb(112, 125, 235) 100%)' }}>
            <div className='card-body p-10'>
              <h2 className='fw-bold text-info text-hover-white mb-5 fs-2'>Advantages to Company</h2>
              <ul className='fs-5 text-gray-800 ps-3'>
                <li className='mb-3'>👉 Platform supports all facets of the Job Fair process, from set-up through execution.</li>
                <li className='mb-3'>👉 Video-first interface enables job seekers and recruiters to see and talk with one another.</li>
                <li className='mb-3'>👉 Dynamic ordering of job seekers using a real-time queueing system.</li>
                <li className='mb-3'>👉 Every part of company can have its own booth, aligning job seekers’ background with company’s needs.</li>
                <li className='mb-3'>👉 No competition for candidates with other hiring companies, as with multi-company Job Fairs.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className='col-lg-5'>
          <div className='card h-100 border-0 shadow rounded-4 bg-white' style={{ background: 'linear-gradient(120deg,rgb(240, 204, 231) 0%,rgb(112, 125, 235) 100%)' }}>
            <div className='card-body p-10'>
              <h2 className='fw-bold text-info text-hover-white mb-5 fs-2'>Advantages to Sponsor</h2>
              <ul className='fs-5 text-gray-800 mb-5 ps-3'>
                <li className='mb-3'>👉 Leverages the power of your print & digital advertising to promote event to your job seeking subscribers.</li>
                <li className='mb-3'>👉 All advertising revenue goes to the Sponsoring Organization.</li>
                <li className='mb-3'>👉 All Job Fair activities are handled by the Virtual Job Fair platform.</li>
                <li className='mb-3'>👉 Enables your client companies to recruit top talent in an efficient and cost-effective manner.</li>
                <li className='mb-3'>👉 Benefits your job-seeking subscribers nationwide by enabling them to interview virtually.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      {/* Terms and Conditions */}
      <div className='row justify-content-center mb-10'>
        <div className='col-lg-10'>
          <div className='card border-0 shadow rounded-3 bg-white'>
            <div className='card-body p-6 text-center'>
              <div className='fs-6 opacity-90 bg-white bg-opacity-10 p-4 rounded-3'>
                <strong>For Job Seekers:</strong> Prior to the Job Fair, users will be given the option to be reminded of the upcoming event using text messages.
                We collect consent for SMS notifications during the{' '}
                <a
                  href='/auth/registration'
                  className='text-warning text-decoration-underline fw-bold'
                >
                  registration process
                </a>.
              </div>
              <label className='form-check-label fw-semibold text-gray-800 fs-5'>
                Please review our {' '}

                <a href='#'
                  className='fw-bold'
                  style={{ textDecoration: 'underline' }}
                  onClick={handleTermsClick}
                >
                  Terms and Conditions
                </a>
                {' '}and{' '}

                <a href='#'
                  className='fw-bold'
                  style={{ textDecoration: 'underline' }}
                  onClick={handlePrivacyClick}
                >
                  Privacy Policy
                </a>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Social Section */}
      <div className='row justify-content-center'>
        <div className='col-lg-10'>
          <div className='d-flex flex-center gap-5 py-7'>
            <a href='https://www.linkedin.com/company/videojobfairs' target='_blank' rel='noopener noreferrer' className='btn btn-icon btn-active-light-primary w-50px h-50px rounded-circle shadow-sm bg-white'>
              <img src={toAbsoluteUrl('/media/svg/social-logos/linkedin-1.svg')} alt='LinkedIn' className='svg-icon svg-icon-2' />
            </a>
            <a href='https://twitter.com/VideoJobFairs' target='_blank' rel='noopener noreferrer' className='btn btn-icon btn-active-light-primary w-50px h-50px rounded-circle shadow-sm bg-white'>
              <img src={toAbsoluteUrl('/media/svg/social-logos/twitter.svg')} alt='Twitter' className='svg-icon svg-icon-2' />
            </a>
            <a href='https://facebook.com/VideoJobFairs' target='_blank' rel='noopener noreferrer' className='btn btn-icon btn-active-light-primary w-50px h-50px rounded-circle shadow-sm bg-white'>
              <img src={toAbsoluteUrl('/media/svg/social-logos/facebook.svg')} alt='Facebook' className='svg-icon svg-icon-2' />
            </a>
          </div>
        </div>
      </div>
      <Modal show={showTermsModal || showPrivacyModal} onHide={() => { setShowTermsModal(false); setShowPrivacyModal(false); }} size="lg" centered >
        <Modal.Header closeButton>
          <Modal.Title>Terms and Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {showTermsModal ? <TnC /> : <PrivacyPolicy />}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => { setShowTermsModal(false); setShowPrivacyModal(false); }}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default Home
